import React, { useState, useEffect, useRef } from 'react';
import { Box } from '@mui/material';
import { useSelector } from 'react-redux';
import { RootState } from 'state/store';
import { Logger } from 'utils/Logger';
import { LocalStorageAuth } from 'utils/LocalStorageAuth';
import { API_BASE_URL } from 'envConfig';

export const ProfileImage = (data: { user?: any; size?: number }) => {
  const loggerMode = useSelector((state: RootState) => state.logger.value);
  const size = data.size ?? 40;
  const [imageSrc, setImageSrc] = useState<string>(
    data.user?.profile?.avatar || '/static/assets/ProfilePicture.jpg'
  );
  const fetchedRef = useRef(false);

  useEffect(() => {
    if (!data.user?._id || fetchedRef.current || !data.user?.profile?.hasProfileImage) return;
    fetchedRef.current = true;

    const loadProfileImage = async () => {
      try {
        const token = LocalStorageAuth.getToken() || '';
        const headers: Record<string, string> = { 'Authorization': `Bearer ${token}` };
        const activeCompanyId = LocalStorageAuth.getActiveCompanyId();
        if (activeCompanyId) headers['X-Active-Company-Id'] = activeCompanyId;

        const resp = await fetch(`${API_BASE_URL}/user/${data.user._id}/profile-image`, { headers });
        if (resp.ok) {
          const blob = await resp.blob();
          setImageSrc(URL.createObjectURL(blob));
        }
      } catch {
        Logger.debug('ProfileImage', 'No binary profile image, using avatar fallback');
      }
    };

    loadProfileImage();
  }, [data.user?._id]);

  Logger.debug('st-ck-client/src/components/Sidebar/Sidebar.tsx/ProfileImage', data.user?.profile?.avatar);

  return (
    <Box
      component="img"
      src={imageSrc}
      height={`${size}px`}
      width={`${size}px`}
      borderRadius="50%"
      sx={{
        objectFit: 'cover',
        border: '1px solid',
        borderColor: 'divider',
        flexShrink: 0,
      }}
    />
  );
};
